import React, { useCallback, useMemo, useState } from "react";

import { All_Project_Setting_List_Post } from "api/ApiConst";

import PageHeading from "components/common/PageHeading";
import PaginationDataTable from "components/common/PaginationDataTable";
import ProjectSettingAddEdit from "./ProjectSettingAddEdit";

const ProjectSettingMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "settingKey",
                name: "Setting Key",
                selector: (row) => row?.key,
                sortable: false,
            },
            {
                id: "Setting Value",
                name: "Setting Value",
                selector: (row) => row?.value,
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => <div className="custom-column-action">{getActionButtons(row)}</div>,
                width: "80px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );
    const customStyles = {
        headCells: {
          style: {
            color: "#000000de", // override the cell padding for head cells
            // fontWeight: "600",
            fontSize: "13px !important",
          },
        },
      };

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                    <i className="bx bx-pencil"></i>
                </button>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.key);
        setShowAddUpdateModal(true);
    };

    return (
        <>
            {PageHeading("Project Setting List", "Dashboard", "/")}
            <div className="card">
                <div className="card-body tableView">
                    <PaginationDataTable paginationUrl={All_Project_Setting_List_Post} serverSidePagination={false} search={false} pagination={false} columns={columns} />
                </div>
            </div>
            {showAddUpdateModal && <ProjectSettingAddEdit show={showAddUpdateModal} hideModal={() => setShowAddUpdateModal(false)} recordID={recordID} handleRefresh={handleRefresh} />}
        </>
    );
};

export default ProjectSettingMaster;
